export default "__VITE_ASSET__U9eO4PNK__"